import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, computed } from '@angular/core';
import { SelectedAttributeService } from '../../services/selected-attribute.service';

@Component({
  selector: 'app-material',
  templateUrl: './material.component.html',
  styleUrls: ['./material.component.scss']
})
export class MaterialComponent {
  @Input() shouldAnimateOut: boolean = false;
  @Input() shouldAnimateIn: boolean = false;
  @Output() navigateToClick = new EventEmitter<any>();
  materialTypes = ['Primary', 'Secondary'];
  selectedPrimaryMaterial = computed(() => this.selectedAttributeService.getValue().primaryMaterial);
  selectedSecondaryMaterial = computed(() => this.selectedAttributeService.getValue().secondaryMaterial);
  primaryMaterialHeight: string = '0px';
  secondaryMaterialHeight: string = '0px';
  visibleSections: string[] = [];
  materialSelectToAnimate: string | null = null;
  materialSelectAnimationDirection: 'In' | 'Out' | null = null;
  hidableSelects: string[] = [];

  constructor(
    private selectedAttributeService: SelectedAttributeService,
    private changeDetectorRef: ChangeDetectorRef
    ) { }

  materialTypeClick(type: string) {
    if (this.visibleSections.includes(type)) {
      this.materialSelectAnimationDirection = 'Out';
    } else {
      this.materialSelectAnimationDirection = 'In';
      this.visibleSections.push(type);
    }
    this.materialSelectToAnimate = type;
  }

  getValueForType(type: string) {
    if (type === 'Primary') {
      return this.selectedPrimaryMaterial()?.displayName;
    } else {
      return this.selectedSecondaryMaterial()?.displayName;
    }
  }

  doesHaveConflict(type: string) {
    return this.selectedAttributeService.getConflicts().includes(`${type}Material`);
  }

  materialSelectInit(type: string, height: number) {
    if (type === 'Primary') {
      this.primaryMaterialHeight = `${height}px`;
    } else {
      this.secondaryMaterialHeight = `${height}px`;
    }
    this.hidableSelects.push(type);
    this.changeDetectorRef.detectChanges();
  }

  doesTypeHaveAvailableMetals(type: string) {
    const availableAttributes = this.selectedAttributeService.availableAttributes
    if (type === 'Primary') {
      // return availableAttributes().primaryMaterial.length > 0;
    } else {
      // return availableAttributes().secondaryMaterial.length > 0;
    }
    throw 'Not implemented'
  }

  @HostListener('animationend', ['$event.target'])
  viewContainerAnimationEnd(target: HTMLElement) {
    if (target.classList.contains('MaterialSelect')) {
      if (this.materialSelectAnimationDirection === 'Out') {
        this.visibleSections = this.visibleSections.filter(v => v !== this.materialSelectToAnimate);
      }
      this.materialSelectToAnimate = null
      this.materialSelectAnimationDirection = null;
    }
  }
}
